import {
  Currency,
  FeePaymentType,
  formatMoney,
  formatPercent,
  getMoneySymbolByCurrency,
} from '@nemuru-eng/js-api-client';

import { LoanConditions } from '@/components/modules/Application/components/PaymentMethod/_shared/types/LoanConditions';
import { SetupFeeDto } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/types/SetupFeeDto';

export class SetupFeeEntity {
  constructor() {}

  public static create(data: {
    currency: Currency;
    amount: number;
    term?: number;
    setupFeeAmount?: number;
    setupFeeType?: FeePaymentType;
  }): SetupFeeDto {
    const { currency, amount, term, setupFeeAmount, setupFeeType } = data;

    const currencySymbol = getMoneySymbolByCurrency(currency);

    const NO_SETUP_FEE = {
      relative: { value: 0, string: '0,00 %' },
      total: { value: 0, string: `0,00 ${currencySymbol}` },
    };

    if (!setupFeeAmount) {
      return NO_SETUP_FEE;
    }

    switch (setupFeeType) {
      case FeePaymentType.TYPE_UPFRONT:
      case FeePaymentType.TYPE_FINANCED:
        return {
          relative: { value: setupFeeAmount / amount, string: formatPercent(setupFeeAmount / amount) },
          total: { value: setupFeeAmount, string: formatMoney({ value: setupFeeAmount, currency }) },
        };
      case FeePaymentType.TYPE_FIXED_AMOUNT:
        if (!term) {
          return NO_SETUP_FEE;
        }
        return {
          relative: {
            value: setupFeeAmount / term,
            string: formatMoney({ value: setupFeeAmount / term, currency }, 2),
          },
          total: { value: setupFeeAmount, string: formatMoney({ value: setupFeeAmount, currency }) },
        };
      default:
        return NO_SETUP_FEE;
    }
  }

  public static fromLoanConditions(loanConditions: LoanConditions, currency: Currency = Currency.EUR): SetupFeeDto {
    const setupFeeAmount =
      loanConditions.setupFee === undefined
        ? undefined
        : loanConditions.setupFee.value <= 1
        ? loanConditions.setupFee.value * loanConditions.principal.value
        : loanConditions.setupFee.value;

    return SetupFeeEntity.create({
      term: loanConditions.term,
      currency: currency,
      setupFeeAmount: setupFeeAmount,
      setupFeeType: loanConditions.setupFeeType,
      amount: loanConditions.principal.value,
    });
  }
}
